import React from "react";

const DeliveyChallanCondition = () => {
  return (
    <div className="mt-3">
      <span style={{fontSize:"15px"}}><b>Terms & Conditions:</b></span>
      <ol style={{ fontSize: "15px" , marginTop:"3px"}}>
        <li>Subject to Pune jurisdiction.</li>
        <li>
          Our responsibility ceases as soon as the goods leave our premises.
        </li>
        <li>Goods once sold will not be taken back.</li>
        <li>Delivery ex-premises.</li>
      </ol>
    </div>
  );
};

export default DeliveyChallanCondition;
